document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.button.is-copy').forEach($button => {
        $button.addEventListener('click', async (event) => {
            event.preventDefault();

            const url = $button.getAttribute('data-url');
            const $icon = $button.querySelector('i');

            if (!url) return;

            try {
                await navigator.clipboard.writeText(url);

                if ($icon) {
                    const originalClass = $icon.className;
                    $icon.className = 'fa-solid fa-check';
                    setTimeout(() => {
                        $icon.className = originalClass;
                    }, 2000);
                }
            } catch (error) {
                console.error('Failed to copy:', error);
            }
        });
    });
});
